document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded');
    // Cache DOM elements
    const elements = {
        loadMoreButton: document.querySelector('[data-load-more]'),
        productList: document.querySelector('#product-list-main'),
        spinnerOverlay: document.querySelector('.collection__spinner-overlay'),
        collectionMenuItems: document.querySelectorAll('[data-category-item]'),
        sortByButtons: document.querySelectorAll('.popover__value-option')
    };
    
    // Initialize state variables
    const state = {
        currentUrl: window.location.href,
        currentSortBy: new URLSearchParams(window.location.search).get('sort_by') || '',
        preloadedImages: new Map() // Store preloaded images
    };
    
    // Get load more container if button exists
    elements.loadMoreContainer = elements.loadMoreButton ? 
        elements.loadMoreButton.closest('[data-load-more-container]') : null;
    
    // Function to initialize product cards and make them visible
    function restoreProductVisibility(container) {
        if (!container) return;
        
        const productCards = container.querySelectorAll('product-card');
        productCards.forEach(card => {
            // Remove any reveal-on-scroll attributes
            card.removeAttribute('reveal-on-scroll');
            
            // Remove any inline styles that might be hiding the card
            card.style.removeProperty('opacity');
            card.style.removeProperty('transform');
            
            // Ensure the card is visible
            card.style.opacity = '1';
            card.classList.add('is-visible');
            
            // Find and restore visibility for any nested elements with reveal-on-scroll
            const revealElements = card.querySelectorAll('[reveal-on-scroll]');
            revealElements.forEach(el => {
                el.removeAttribute('reveal-on-scroll');
                el.style.opacity = '1';
                el.style.removeProperty('transform');
            });
        });
    }
    
    // Function to handle loading more products
    function handleLoadMore(e, button) {
        
        e.preventDefault();
        
        // Show loading spinner, hide button
        elements.spinnerOverlay.style.display = 'flex';
        button.style.display = 'none';
        
        // Store the current number of products before loading more
        const currentProductCount = elements.productList.querySelectorAll('product-card').length;
        
        // Fetch next page
        fetch(button.href)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Get products from the next page
                const newProductList = doc.querySelector('#product-list-main');
                
                // Remove any promotion elements from the new content before appending
                const promotionsInNewContent = newProductList.querySelectorAll('.collection-promotion');
                promotionsInNewContent.forEach(promo => promo.remove());
                
                // Append new products to the current product list
                elements.productList.innerHTML += newProductList.innerHTML;
                
                // Force a reflow to ensure the browser recognizes the new elements
                void elements.productList.offsetHeight;
                
                // Restore visibility for all products
                setTimeout(() => {
                    restoreProductVisibility(elements.productList);
                }, 100);
                
                // Update the load more button URL to the next page
                const nextPageLink = doc.querySelector('[data-load-more]');
                if (nextPageLink) {
                    button.href = nextPageLink.href;
                    button.style.display = 'inline-block';
                } else {
                    // No more pages, hide the button container
                    const container = button.closest('[data-load-more-container]');
                    if (container) {
                        container.style.display = 'none';
                    }
                }
                
                // Update URL without page reload
                const url = new URL(window.location.href);
                if (state.currentSortBy) {
                    url.searchParams.set('sort_by', state.currentSortBy);
                }
                history.replaceState({}, '', url.toString());
                state.currentUrl = url.toString();
                
                // Update page title if available in the fetched document
                // updatePageTitle(doc);
                // Hide spinner
                // window.initCollectionUsP();
                // Re-init the colour swatch sliders for the products appended by
                // "load more". This previously read the reference without calling it
                // (`window.initColorSwatches;`), so it was a no-op and newly loaded
                // swatches were left uninitialised.
                if (typeof window.initColorSwatches === 'function') {
                    window.initColorSwatches();
                }
                elements.spinnerOverlay.style.display = 'none';
            })
            .catch(error => {
                console.error('Error loading more products:', error);
                button.style.display = 'inline-block';
                elements.spinnerOverlay.style.display = 'none';
            });
    }

    
    // Function to update page title and related elements
    function updatePageTitle(doc) {
        const newTitle = doc.querySelector('title');
        if (newTitle && newTitle.textContent) {
            document.title = newTitle.textContent;
            
            // Update any elements with data-change-title attribute
            const titleElements = document.querySelectorAll('[data-change-title]');
            titleElements.forEach(el => {
                el.textContent = newTitle.textContent.split('(')[0];
            });
        }
    }
    
    // Function to update product list and related elements
    function updateProductList(doc, url) {
        // Update product list
        const newProductList = doc.querySelector('#product-list-main');
        if (newProductList) {
            elements.productList.innerHTML = newProductList.innerHTML;
            
            // Restore visibility for the newly loaded products
            setTimeout(() => {
                restoreProductVisibility(elements.productList);
            }, 100);
        }
        
        // Update load more button and container
        updateLoadMoreButton(doc);
        
        // Update product count if it exists
        const productsCount = doc.querySelector('.collection-toolbar__products-count');
        const currentProductsCount = document.querySelector('.collection-toolbar__products-count');
        if (productsCount && currentProductsCount) {
            currentProductsCount.textContent = productsCount.textContent;
        }
        
        // Update URL without page reload
        history.pushState({}, '', url);
        state.currentUrl = url;
        
        // Update page title
        updatePageTitle(doc);
    }
    
    // Function to update the entire page content
    function updateEntirePage(doc, url) {
        // Get the new main content
        const newMainContent = doc.querySelector('main');
        const currentMainContent = document.querySelector('main');
        
        if (newMainContent && currentMainContent) {
            console.log('Updating main content');
            
            // Save scroll position
            const scrollPosition = window.scrollY;
            
            // Save footer-usp and footer sections before updating
            const footerUsp = currentMainContent.querySelector('section.footer-usp');
            const footer = currentMainContent.querySelector('footer');
            
            // Replace the main content
            currentMainContent.innerHTML = newMainContent.innerHTML;
            
            // Find the new footer-usp and footer in the updated main content
            const newFooterUsp = currentMainContent.querySelector('section.footer-usp');
            const newFooter = currentMainContent.querySelector('footer');
            
            // If we have saved footer sections and they exist in the new content, replace them
            if (footerUsp && newFooterUsp) {
                newFooterUsp.parentNode.replaceChild(footerUsp, newFooterUsp);
            }
            
            if (footer && newFooter) {
                newFooter.parentNode.replaceChild(footer, newFooter);
            }
            
            // Re-initialize event listeners and functionality
            // This is necessary because replacing innerHTML removes all event listeners
            reinitializePageFunctionality();
            
            // Update URL without page reload
            history.pushState({}, '', url);
            state.currentUrl = url;
            
            // Update page title
            const newTitle = doc.querySelector('title');
            if (newTitle && newTitle.textContent) {
                document.title = newTitle.textContent;
            }
            
            // Scroll to top or maintain position
            window.scrollTo(0, 0);
        } else {
            console.warn('Main content element not found in new or current document');
        }
    }
    
    // Function to reinitialize event listeners after full page update
    function reinitializePageFunctionality() {
        // Re-cache DOM elements
        elements.loadMoreButton = document.querySelector('[data-load-more]');
        elements.productList = document.querySelector('#product-list-main');
        elements.spinnerOverlay = document.querySelector('.collection__spinner-overlay');
        elements.collectionMenuItems = document.querySelectorAll('[data-category-item]');
        elements.sortByButtons = document.querySelectorAll('.popover__value-option');
        
        // Get load more container if button exists
        elements.loadMoreContainer = elements.loadMoreButton ? 
            elements.loadMoreButton.closest('[data-load-more-container]') : null;
        
        // Reinitialize Swiper sliders by triggering their initialization code
        reinitializeSwipers();
        
        // Reinitialize load more functionality
        if (elements.loadMoreButton && elements.productList) {
            elements.loadMoreButton.addEventListener('click', e => handleLoadMore(e, elements.loadMoreButton));
        }
        
        // Reinitialize collection menu functionality
        if (elements.collectionMenuItems.length > 0) {
            elements.collectionMenuItems.forEach(item => {
                if (!item.hasAttribute('data-custom-filter') && !item.hasAttribute('data-collection-handle')) {
                    return;
                }
                
                item.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    // Update active state
                    elements.collectionMenuItems.forEach(menuItem => menuItem.classList.remove('active'));
                    this.classList.add('active');
                    
                    // Show loading spinner
                    elements.spinnerOverlay.style.display = 'flex';
                    
                    let url = this.getAttribute('href');
                    
                    // Preserve sort parameter if it exists
                    if (state.currentSortBy) {
                        url = new URL(url, window.location.origin);
                        url.searchParams.set('sort_by', state.currentSortBy);
                        url = url.toString();
                    }
                    
                    // Update image immediately since it's already preloaded
                    updateImage(item);
                    
                    // Fetch collection products
                    fetch(url)
                        .then(response => response.text())
                        .then(html => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');
                            
                            // Use the new function to update the entire page
                            updateEntirePage(doc, url);
                            
                            // Hide spinner
                            const spinner = document.querySelector('.collection__spinner-overlay');
                            if (spinner) {
                                spinner.style.display = 'none';
                            }
                        })
                        .catch(error => {
                            console.error('Error loading collection products:', error);
                            elements.spinnerOverlay.style.display = 'none';
                        });
                });
            });
        }
        
        // Reinitialize sort by functionality
        if (elements.sortByButtons.length > 0) {
            elements.sortByButtons.forEach(button => {
                button.addEventListener('click', function() {
                    const sortValue = this.getAttribute('value');
                    state.currentSortBy = sortValue;
                    
                    // Update URL with sort parameter
                    const url = new URL(state.currentUrl);
                    url.searchParams.set('sort_by', sortValue);
                    const sortUrl = url.toString();
                    
                    // Show loading spinner
                    elements.spinnerOverlay.style.display = 'flex';
                    
                    // Fetch sorted products
                    fetch(sortUrl)
                        .then(response => response.text())
                        .then(html => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');
                            
                            // Use the new function to update the entire page
                            updateEntirePage(doc, sortUrl);
                            
                            // Hide spinner
                            const spinner = document.querySelector('.collection__spinner-overlay');
                            if (spinner) {
                                spinner.style.display = 'none';
                            }
                        })
                        .catch(error => {
                            console.error('Error sorting products:', error);
                            elements.spinnerOverlay.style.display = 'none';
                        });
                });
            });
        }
        
        // Initialize product cards on page load
        restoreProductVisibility(elements.productList);
        
        // Setup responsive image handling
        setupResponsiveImageHandling();
        
        // Preload all collection images
        preloadAllCollectionImages();

        // Guard for the same reason as reinitializeSwipers(): these globals are
        // defined by theme snippets/scripts that are not guaranteed to be present
        // for every collection layout. A missing reference here would otherwise
        // abort the rest of the re-init and break navigation.
        if (typeof window.initColorSwatches === 'function') {
            window.initColorSwatches();
        }
    }
    
    // Function to update load more button
    function updateLoadMoreButton(doc) {
        const newLoadMoreContainer = doc.querySelector('[data-load-more-container]');
        const currentLoadMoreContainer = document.querySelector('[data-load-more-container]');
        
        if (newLoadMoreContainer) {
            // If we have a new load more container, replace or add it
            if (currentLoadMoreContainer) {
                currentLoadMoreContainer.innerHTML = newLoadMoreContainer.innerHTML;
                currentLoadMoreContainer.style.display = 'block';
                
                // Re-attach event listener to the new load more button
                const newLoadMoreButton = currentLoadMoreContainer.querySelector('[data-load-more]');
                if (newLoadMoreButton) {
                    newLoadMoreButton.addEventListener('click', e => handleLoadMore(e, newLoadMoreButton));
                }
            } else if (elements.productList.parentNode) {
                // If there's no current container but we need one, add it
                const newContainer = newLoadMoreContainer.cloneNode(true);
                elements.productList.parentNode.appendChild(newContainer);
                
                // Add event listener to the new button
                const newButton = newContainer.querySelector('[data-load-more]');
                if (newButton) {
                    newButton.addEventListener('click', e => handleLoadMore(e, newButton));
                }
            }
        } else if (currentLoadMoreContainer) {
            // If there's no new load more container but we have one, hide it
            currentLoadMoreContainer.style.display = 'none';
        }
    }

    function updateImage(item) {
        if (!item.dataset.collectionImage) return;
        
        const pictureElement = document.querySelector('.collection-banner picture');
        if (!pictureElement) return;
        
        // Get the image element (this is the desktop image)
        const imageElement = pictureElement.querySelector('.collection-banner__image');
        if (!imageElement) return;
        
        // Get any existing source element (this is for mobile)
        const sourceElement = pictureElement.querySelector('source');
        
        // Update desktop image
        imageElement.src = item.dataset.collectionImage;
        
        // If there are srcset attributes, we should update those too
        if (imageElement.srcset) {
            // Create a base URL without size parameters
            const baseUrl = item.dataset.collectionImage.split('?')[0];
            
            // Generate new srcset based on the original pattern
            const widths = [300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600, 2800, 3000, 3200];
            const newSrcset = widths.map(width => 
                `${baseUrl}?width=${width} ${width}w`
            ).join(', ');
            
            imageElement.srcset = newSrcset;
        }
        
        // Update mobile image if available
        if (sourceElement && item.dataset.mobileCollectionImage) {
            // Create a base URL without size parameters for mobile
            const mobileBaseUrl = item.dataset.mobileCollectionImage.split('?')[0];
            
            // Generate new srcset for mobile
            const mobileWidths = [400, 600, 800, 1000];
            const newMobileSrcset = mobileWidths.map(width => 
                `${mobileBaseUrl}?width=${width} ${width}w`
            ).join(', ');
            
            sourceElement.srcset = newMobileSrcset;
        } else if (item.dataset.mobileCollectionImage && !sourceElement) {
            // If we have a mobile image but no source element, create one
            const newSource = document.createElement('source');
            newSource.media = '(max-width: 699px)';
            
            // Create srcset for the new source element
            const mobileBaseUrl = item.dataset.mobileCollectionImage.split('?')[0];
            const mobileWidths = [400, 600, 800, 1000];
            const newMobileSrcset = mobileWidths.map(width => 
                `${mobileBaseUrl}?width=${width} ${width}w`
            ).join(', ');
            
            newSource.srcset = newMobileSrcset;
            
            // Insert the new source element before the image
            pictureElement.insertBefore(newSource, imageElement);
        } else if (sourceElement && !item.dataset.mobileCollectionImage) {
            // If we have a source element but no mobile image, remove the source element
            sourceElement.remove();
        }
    }
    
    // Preload all collection images when page loads
    function preloadAllCollectionImages() {
        // Make sure we have a valid state.preloadedImages Map
        if (!state.preloadedImages) {
            state.preloadedImages = new Map();
        }
        
        // Get all elements with collection images
        elements.collectionMenuItems.forEach(item => {
            // Handle desktop collection image
            if (item.dataset.collectionImage) {
                const img = new Image();
                img.src = item.dataset.collectionImage;
                state.preloadedImages.set(item.dataset.collectionImage, img);
            }
            
            // Handle mobile collection image
            if (item.dataset.mobileCollectionImage) {
                const mobileImg = new Image();
                mobileImg.src = item.dataset.mobileCollectionImage;
                state.preloadedImages.set(item.dataset.mobileCollectionImage, mobileImg);
            }
        });
    }
    
    // Call the preload function immediately
    preloadAllCollectionImages();
    
    // Initialize load more functionality
    if (elements.loadMoreButton && elements.productList) {
        elements.loadMoreButton.addEventListener('click', e => handleLoadMore(e, elements.loadMoreButton));
    }
    
    // Initialize collection menu functionality
    if (elements.collectionMenuItems.length > 0) {
        // We don't need to preload images here anymore since we're doing it at page load
        
        elements.collectionMenuItems.forEach(item => {
            if (!item.hasAttribute('data-custom-filter') && !item.hasAttribute('data-collection-handle')) {
                return;
            }
            
            item.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Update active state
                elements.collectionMenuItems.forEach(menuItem => menuItem.classList.remove('active'));
                this.classList.add('active');
                
                // Show loading spinner
                elements.spinnerOverlay.style.display = 'flex';
                
                let url = this.getAttribute('href');
                
                // Preserve sort parameter if it exists
                if (state.currentSortBy) {
                    url = new URL(url, window.location.origin);
                    url.searchParams.set('sort_by', state.currentSortBy);
                    url = url.toString();
                }
                
                // Update image immediately since it's already preloaded
                updateImage(item);
                
                // Fetch collection products
                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        
                        // Use the new function to update the entire page
                        updateEntirePage(doc, url);
                        
                        // Hide spinner
                        const spinner = document.querySelector('.collection__spinner-overlay');
                        if (spinner) {
                            spinner.style.display = 'none';
                        }
                    })
                    .catch(error => {
                        console.error('Error loading collection products:', error);
                        elements.spinnerOverlay.style.display = 'none';
                    });
            });
        });
    }
    
    // Initialize sort by functionality
    if (elements.sortByButtons.length > 0) {
        elements.sortByButtons.forEach(button => {
            button.addEventListener('click', function() {
                const sortValue = this.getAttribute('value');
                state.currentSortBy = sortValue;
                
                // Update URL with sort parameter
                const url = new URL(state.currentUrl);
                url.searchParams.set('sort_by', sortValue);
                const sortUrl = url.toString();
                
                // Show loading spinner
                elements.spinnerOverlay.style.display = 'flex';
                
                // Fetch sorted products
                fetch(sortUrl)
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        
                        // Use the new function to update the entire page
                        updateEntirePage(doc, sortUrl);
                        
                        // Hide spinner
                        const spinner = document.querySelector('.collection__spinner-overlay');
                        if (spinner) {
                            spinner.style.display = 'none';
                        }
                    })
                    .catch(error => {
                        console.error('Error sorting products:', error);
                        elements.spinnerOverlay.style.display = 'none';
                    });
            });
        });
    }
    
    // Initialize product cards on page load
    restoreProductVisibility(elements.productList);

    // Also add a window resize handler to switch images when screen size changes
    function setupResponsiveImageHandling() {
        let lastWidth = window.innerWidth;
        const mobileBreakpoint = 700;
        
        window.addEventListener('resize', function() {
            // Only trigger if we cross the mobile breakpoint
            if ((lastWidth < mobileBreakpoint && window.innerWidth >= mobileBreakpoint) ||
                (lastWidth >= mobileBreakpoint && window.innerWidth < mobileBreakpoint)) {
                
                // Get the currently active collection item
                const activeItem = document.querySelector('[data-category-item].active');
                if (activeItem) {
                    updateImage(activeItem);
                } else {
                    // If no active item, update with the first item
                    const firstItem = document.querySelector('[data-category-item]');
                    if (firstItem) {
                        updateImage(firstItem);
                    }
                }
                
                lastWidth = window.innerWidth;
            }
        });
    }

    // Setup responsive image handling
    setupResponsiveImageHandling();
    
    function reinitializeSwipers() {
        // `initCollectionUsP` is only defined when the collection USP swiper snippet
        // renders, and that snippet is gated to appear after the 7th product card
        // (`display_index == 7` in main-collection-sets.liquid). On sets collections
        // that show fewer than 7 deduped cards — either by catalogue size
        // (e.g. /collections/gietijzeren-braadpan) or because the visitor landed on a
        // filtered URL with few results (e.g. /collections/pannenset?filter...) — the
        // snippet never renders, so `window.initCollectionUsP` stays undefined.
        // Calling it unguarded threw "window.initCollectionUsP is not a function",
        // which aborted updateEntirePage() before the content swap and left category /
        // sort navigation dead (no results update, no URL change) plus a logged error.
        // Guard it so reinitialisation always completes; there is nothing to init when
        // the USP swiper is absent anyway.
        if (typeof window.initCollectionUsP === 'function') {
            window.initCollectionUsP();
        }
    }
});


///NOTE!!! Do a code review on this file and make sure it's not causing any issues with the collection page.